import React from "react";
import {CardWrapper} from "../components/card-wrapper/card-wrapper";
import {useFormik} from "formik";
import {Grid} from "@material-ui/core";
import {StyledInput} from "../components/form/input";
import {StyledButton} from "../components/ui-base/button";
import {AuthService} from "../services/auth.service";
import {showSnackSuccess} from "../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

const ChangePasswordPage = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    const changePasswordForm = useFormik({
        initialValues: {
            oldPassword: '',
            newPassword: '',
            reNewPassword: ''
        },
        onSubmit: async values => {
            const res = await AuthService.changePassword(values.oldPassword, values.newPassword, values.reNewPassword);

            if (res) {
                dispatch(showSnackSuccess(t('changePassword.passChanged')));
                changePasswordForm.resetForm();
            }
        }
    })

    return (
        <CardWrapper title={t('changePassword.changePass')} subtitle={''} style={{maxWidth: '600px', maxHeight: '420px', margin: '0 auto'}}>
            <form onSubmit={changePasswordForm.handleSubmit} style={{width: '100%'}}>
                <Grid container spacing={2} direction="column">
                    <Grid item>
                        <StyledInput
                            id="oldPassword"
                            label={t('changePassword.oldPass')}
                            type={"password"}
                            onChange={changePasswordForm.handleChange}
                            value={changePasswordForm.values.oldPassword}
                        />
                    </Grid>
                    <Grid item>
                        <StyledInput
                            id="newPassword"
                            label={t('changePassword.newPass')}
                            type={"password"}
                            onChange={changePasswordForm.handleChange}
                            value={changePasswordForm.values.newPassword}
                        />
                    </Grid>
                    <Grid item>
                        <StyledInput
                            id="reNewPassword"
                            label={t('changePassword.reNewPass')}
                            type={"password"}
                            onChange={changePasswordForm.handleChange}
                            value={changePasswordForm.values.reNewPassword}
                        />
                    </Grid>
                    <Grid item container direction="row" justifyContent="flex-end">
                        <StyledButton type="submit">
                            {t('save')}
                        </StyledButton>
                    </Grid>
                </Grid>
            </form>
        </CardWrapper>
    )
}

export default ChangePasswordPage;
